import * as Raven from 'raven-js';
import { get } from 'lodash';
import toast from '../util/toast';
import { createAxiosWithOauth2Handling } from '../util/authHelper';


function onDownloadRequestSuccess(bookIds, url, isOnepun) {
  const payload = JSON.stringify({ b_ids: bookIds });
  const appUri = `${url}&payload=${encodeURIComponent(payload)}`;

  if (Ridi.globals.isRidiApp) {
    if (Ridi.globals.isPaper) {
      // isRidiApp이면서 isPaper이면 앱 내 서점이므로 그대로 navigate하면 앱에서 인식함
      window.location.href = appUri;
    } else if (navigator.appVersion <= 6.30) {
      // 6.x 버전까지는 goDownload 지원 필요
      window.location.href = 'app:/goDownload/';
    } else {
      window.location.href = appUri;
    }
  } else {
    launchAppToDownload(appUri, isOnepun);
  }
}

// 앱 호출 URI를 안드로이드 intent를 이용해 호출할 수 있는 URI로 변환해주는 함수
function convertUriToAndroidIntentUri(uri, isOnepun) {
  const scheme = /(.+):\/\//.exec(uri)[1];
  if (!isOnepun) {
    // 줄바꿈시 공백이 들어가서 다운로드 URI 오류 발생
    return `${uri.replace(`${scheme}://`, 'intent://')}#Intent;scheme=${scheme};action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.initialcoms.ridi;end`;
  }
  return `${uri.replace(`${scheme}://`, 'ridionestore://')}`;
}

function launchAppToDownload(appUri, isOnepun) {
  const { appVersion } = navigator;
  const isIos = (/iphone|ipad|ipod/gi).test(appVersion);
  // 2022.01.03 기준으로 삼성 브라우저가 데스크톱 모드가 아님에도 불구하고,
  // User-Agent의 운영체제 값이 Android 대신 X11인 버그가 있습니다.
  // 따라서 이 버그가 수정되기 전 까지 삼성 브라우저일 시, 안드로이드로 구분되도록 "SamsungBrowser"를 체크합니다.
  const isAndroid = /(?:android|SamsungBrowser)/gi.test(appVersion);
  const isIE = (/MSIE|Trident\//g).test(appVersion);
  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  const start = new Date();

  // 만약 앱이 깔려있으면 iframe에 주소가 세팅되자마자 앱이 실행되서 아래 함수가 실제로 실행되지 않는 원리를 이용함
  const installTimer = setTimeout(() => {
    // 이렇게 빨리 여기로 들어오면 앱이 실행되지 않았다고 판단
    if (new Date() - start < 2500) {
      if (isIos) {
        toast.show({
          text: '리디 앱에서 작품을 볼 수 있습니다.',
          linkUrl: 'https://apps.apple.com/kr/app/id338813698?mt=8',
          linkTitle: '앱 다운로드 받기',
        }, 8000);
      } else if (isAndroid && isOnepun) {
        toast.show({
          text: '리디 앱에서 작품을 볼 수 있습니다.',
          linkUrl: 'https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000764476',
          linkTitle: '앱 다운로드 받기',
        }, 8000);
      } else if (isAndroid && !isOnepun) {
        toast.show({
          text: '리디 앱에서 작품을 볼 수 있습니다.',
          linkUrl: 'https://play.google.com/store/apps/details?id=com.initialcoms.ridi',
          linkTitle: '앱 다운로드 받기',
        }, 8000);
      } else if (Ridi.globals.isPc) {
        $('#iframe_book_download').attr('src', '');
        toast.show({
          text: 'PC 뷰어에서 작품을 볼 수 있습니다.',
          linkUrl: '/support/app',
          linkTitle: '이용 방법 보기',
        }, 8000);
      } else {
        toast.show({
          text: '리디 앱에서 작품을 볼 수 있습니다.',
          linkUrl: '/support/app',
          linkTitle: '이용 방법 보기',
        }, 8000);
      }
    }
  }, 1500);

  if (isIos) {
    try {
      window.location = appUri;
    } catch (e) {
      // TODO: Handle error.
    }
  } else if (isAndroid) {
    const androidUri = isFirefox ? appUri : convertUriToAndroidIntentUri(appUri, isOnepun);

    setTimeout(() => {
      try {
        document.location.href = androidUri;
      } catch (e) {
        document.location.href = appUri;
      }

      // clearTimeout(installTimer);
    }, 300);
  } else {
    $('#iframe_book_download').attr('src', appUri);
  }

  return false;
}

const download = {
  trigger({
    bookIds, seriesIds, preprocess, onSuccess, isOnepun,
  }) {
    const data = {
      b_ids: bookIds,
      series_ids: seriesIds,
    };
    if (preprocess) {
      data.preprocess = true;
    }
    createAxiosWithOauth2Handling().get('/api/user_books/trigger_download', {
      params: data,
    }).then(result => {
      const safetyData = get(result, 'data', null);
      if (safetyData) {
        if (typeof onSuccess !== 'function') {
          onDownloadRequestSuccess(result.data.b_ids, result.data.url, isOnepun);
        } else {
          onSuccess(result.data.b_ids, result.data.url);
        }
      } else {
        toast.fail('일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      }
    }).catch(error => {
      Raven.captureException(error, {
        tags: {
          api: 'trigger_download',
        },
      });
    });
  },

  download(requestedBookIds, type, redirectURL = '', isOnepun = false) {
    const bookIds = typeof requestedBookIds === 'string' ? [bookIds] : requestedBookIds;

    if (bookIds.length === 0) {
      toast.fail('다운로드할 책을 선택해주세요.');
      return false;
    }

    // TODO: type이 userbook인 경우는 triggerDownload가 직접 불리도록 모두 수정할 것
    if (type === 'userbook') {
      this.trigger(bookIds, [], true);
      return false;
    }

    if (type === 'free') {
      // 무료책 다운로드 Client API가 있다면, 기기등록 없이 다운로드할 수 있게
      if (typeof _native !== 'undefined' && _native.downloadFreeBook !== undefined) {
        _native.downloadFreeBook(bookIds[0]);
        return false;
      }
    }

    createAxiosWithOauth2Handling().get(`/library/download-books?type=${type}&book_ids[]=${bookIds}`).then(result => {
      const { data } = result;
      if (data.result) {
        if (redirectURL !== '') {
          window.location.href = redirectURL;
        } else {
          onDownloadRequestSuccess(data.b_ids, data.url, isOnepun);
        }
      } else if (data.redirect) {
        if (window.confirm(data.message)) {
          window.location.href = data.redirect;
        }
      } else {
        toast.fail(data.message);
      }
    }).catch(error => {
      Raven.captureException(error, {
        tags: {
          api: 'download-books',
        },
      });
    });

    return false;
  },

  /**
   * 특정 서비스 타입의 구매목록으로 이동
   * @param serviceType
   */
  launchAppPurchasedList(isOnepun = false) {
    $.get(
      '/library/get-app-purchased-list-uri-scheme', '',
      data => {
        if (data.result) {
          if (Ridi.globals.isRidiApp && Ridi.globals.isPaper) {
            // isRidiApp이면서 isPaper이면 앱 내 서점이므로 그대로 navigate하면 앱에서 인식함
            window.location.href = data.uri_scheme;
          } else {
            launchAppToDownload(data.uri_scheme, isOnepun);
          }
        } else {
          toast.fail('일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        }
      },
      'json',
    );
  },
};

export default download;



// WEBPACK FOOTER //
// ./common/download.lib.js